export var MY_PROFILE_PATH = '/my-profile/';
export var CHANGE_EMAIL_INVITATION_BASE_PATH = '/email-changed-confirmation/';
export var CHANGE_EMAIL_INVITATION_PATH = "".concat(CHANGE_EMAIL_INVITATION_BASE_PATH, ":code");
